import { api } from "./_client";

/**
 * Submit the public landing-page contact form. Backend pipes it to
 * Resend and stores a copy in Mongo. Never requires auth.
 */
export async function submitContactForm({ name, email, phone, message, website = "" }) {
    const { data } = await api.post("/contact", {
        name,
        email,
        phone,
        message,
        website, // honeypot
    });
    return data;
}
